module.exports = __webpack_public_path__ + "img/parents-11.17cb87c4.jpg";